import { siteConfig } from "./site.config";

export type CheckoutOfferKey = "offer7" | "offer3" | "offer5";

export async function startCheckoutSession(offerKey: CheckoutOfferKey): Promise<void> {
  const base = siteConfig.api.base;
  const res = await fetch(`${base}/api/create-checkout-session`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ offerKey }),
  });
  const data = (await res.json()) as { url?: string; error?: string };
  if (!res.ok) {
    throw new Error(data.error || "Checkout failed");
  }
  if (data.url) {
    window.location.href = data.url;
    return;
  }
  throw new Error("No checkout URL returned");
}
